import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaDashboard = {
  index: async(props) => {
    const { default: DashboardIndex } = await import('@/vue_widgets/lsa/dashboard/index.vue')
    createVueApp(DashboardIndex, { props, sidebar })
  }
}
